import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    getUnmatchedResultsSuccess, getUnmatchedResultsFailure,
    getUnmatchedResultsCountSuccess, getUnmatchedResultsCountFailure,
    assignUnmatchedResultSuccess, assignUnmatchedResultFailure,
    batchAssignUnmatchedResultSuccess, batchAssignUnmatchedResultFailure,
    discardUnmatchedResultSuccess, discardUnmatchedResultFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

const BASE = `${process.env.REACT_APP_SERVER_API}api/laboratory/unmatched-results`;

function* listRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { status = 'pending', analyzerId = '', page = 1, limit = 25, dateFrom = '', dateTo = '' } = action.payload || {};
        let url = `${BASE}?status=${status}&page=${page}&limit=${limit}`;
        if (analyzerId) url += `&analyzerId=${analyzerId}`;
        if (dateFrom) url += `&dateFrom=${encodeURIComponent(dateFrom)}`;
        if (dateTo) url += `&dateTo=${encodeURIComponent(dateTo)}`;
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(getUnmatchedResultsSuccess(response));
    } catch (error) { yield put(getUnmatchedResultsFailure(error?.response?.message || error)); }
}

function* countRequest() {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${BASE}/count`, requestDetail);
        yield put(getUnmatchedResultsCountSuccess(response));
    } catch (error) { yield put(getUnmatchedResultsCountFailure(error?.response?.message || error)); }
}

function* assignRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { id, labOrderId } = action.payload;
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify({ labOrderId })
        };
        const response = yield call(requestHandler, `${BASE}/${id}/assign`, requestDetail);
        yield put(assignUnmatchedResultSuccess(response));
    } catch (error) { yield put(assignUnmatchedResultFailure(error?.response?.message || error)); }
}

function* batchAssignRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { ids, labOrderId } = action.payload;
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify({ ids, labOrderId })
        };
        const response = yield call(requestHandler, `${BASE}/batch-assign`, requestDetail);
        yield put(batchAssignUnmatchedResultSuccess(response));
    } catch (error) { yield put(batchAssignUnmatchedResultFailure(error?.response?.message || error)); }
}

function* discardRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { id, reason } = action.payload;
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify({ reason })
        };
        const response = yield call(requestHandler, `${BASE}/${id}/discard`, requestDetail);
        yield put(discardUnmatchedResultSuccess(response));
    } catch (error) { yield put(discardUnmatchedResultFailure(error?.response?.message || error)); }
}

function* saga() {
    yield takeLatest('labUnmatchedResult/getUnmatchedResultsRequest', listRequest);
    yield takeLatest('labUnmatchedResult/getUnmatchedResultsCountRequest', countRequest);
    yield takeLatest('labUnmatchedResult/assignUnmatchedResultRequest', assignRequest);
    yield takeLatest('labUnmatchedResult/batchAssignUnmatchedResultRequest', batchAssignRequest);
    yield takeLatest('labUnmatchedResult/discardUnmatchedResultRequest', discardRequest);
}

export default saga;
